/* eslint-disable */
import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { ClientContext } from "ClientProvider";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";

export const SidebarLinks = (props: { routes: RoutesType[]; onClose:any }): JSX.Element => {
  const { singleRoleData, setActiveTab , setActiveSettlementTab,setSettlementActiveTab } = useContext(ClientContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { routes,onClose } = props;
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const activeRoute = (routePath: string) => {
    const currentPath = location.pathname.replace("/admin", "");
    return currentPath === routePath || currentPath === `/${routePath}`;
  };

  const routeHiden = (route: any) => {
    let isStatus = false;
    if (route?.path === singleRoleData?.[0]?.payment_method?.name?.replace(" ", "")) {
      isStatus = singleRoleData?.[0]?.payment_method?.value?.view_payment_method_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === singleRoleData?.[0]?.subscription?.name?.replace(" ", "")) {
      isStatus = singleRoleData?.[0]?.subscription?.value?.view_subscription_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === singleRoleData?.[0]?.client?.name?.replace(" ", "") + "s") {
      isStatus = singleRoleData?.[0]?.client?.value?.view_client_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === singleRoleData?.[0]?.customers?.name?.replace(" ", "")) {
      isStatus = singleRoleData?.[0]?.customers?.value?.view_customers;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === singleRoleData?.[0]?.settlement?.name?.replace(" ", "")) {
      isStatus = singleRoleData?.[0]?.settlement?.value?.view_settlement_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === singleRoleData?.[0]?.organization?.name?.replace(" ", "") + "s") {
      isStatus = singleRoleData?.[0]?.organization?.value?.view_organization_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === singleRoleData?.[0]?.payment?.name?.replace(" ", "") + "s") {
      isStatus = singleRoleData?.[0]?.payment?.value?.view_payment_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path == singleRoleData?.[0]?.token?.name?.replace(" ", "") + "s") {
      isStatus = singleRoleData?.[0]?.token?.value?.view_token_list;
      if (location?.pathname === route?.layout + "/" + route?.path && !isStatus) navigate("/admin/dashboard");
    }
    if (route?.path === "payout") {
      isStatus = singleRoleData?.[0]?.payout?.value?.view_payout_list || singleRoleData?.[0]?.payout?.value?.view_batch_payout;
    }
    if (route?.path === "fiat-payout") {
      isStatus = singleRoleData?.[0]?.fiat?.value?.view_fiat_payout_list || singleRoleData?.[0]?.fiat?.value?.view_single_fiat_payout_list;
    }
    if (route?.name === "Dashboard") isStatus = true;
    if (route?.name === "Platform Management") {
      isStatus = singleRoleData?.[0]?.user?.value?.view_user_list ||
        singleRoleData?.[0]?.role?.value?.view_role_list ||
        singleRoleData?.[0]?.api_request_logs?.value?.view_api_request_logs ||
        singleRoleData?.[0]?.audit_logs?.value?.view_user_audit_logs ||
        singleRoleData?.[0]?.blacklist?.value?.view_blacklist_list ||
        singleRoleData?.[0]?.kyc_velocity?.value?.view_kyc_velocity ||
        singleRoleData?.[0]?.settings?.value?.view_settings ||
        singleRoleData?.[0]?.api?.value?.view_api_list;
    }
    if (route?.name === "Crypto") {
      isStatus = singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_list ||
        singleRoleData?.[0]?.crypto?.value?.view_single_crypto_payout_list ||
        singleRoleData?.[0]?.crypto?.value?.view_crypto_payin;
    }
    return isStatus;
  };

  const hasChildPermission = (child: RoutesType) => {
    switch (child.name) {
      case "Users":          return singleRoleData?.[0]?.user?.value?.view_user_list;
      case "Payout":         return singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_list || singleRoleData?.[0]?.crypto?.value?.view_single_crypto_payout_list;
      case "Payin":          return singleRoleData?.[0]?.crypto?.value?.view_crypto_payin;
      case "Role":           return singleRoleData?.[0]?.role?.value?.view_role_list;
      case "API Request Logs": return singleRoleData?.[0]?.api_request_logs?.value?.view_api_request_logs;
      case "Audit Logs":     return singleRoleData?.[0]?.audit_logs?.value?.view_user_audit_logs;
      case "Blacklist":      return singleRoleData?.[0]?.blacklist?.value?.view_blacklist_list;
      case "Kyc Velocity":   return singleRoleData?.[0]?.kyc_velocity?.value?.view_kyc_velocity;
      case "Settings":       return singleRoleData?.[0]?.settings?.value?.view_settings;
      case "API Access":     return singleRoleData?.[0]?.api?.value?.view_api_list;
      default:               return true;
    }
  };

  const toggleMenu = (menuName: string) => {
    setOpenMenus((prev) => {
      const isCurrentlyOpen = prev[menuName];
      return isCurrentlyOpen ? {} : { [menuName]: true };
    });
  };

  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route, index) => {
      if (route.layout === "/admin" && routeHiden(route)) {
        const isOpen = !!openMenus[route.name];
        const isActive = activeRoute(route.path);

        /* ── Group / parent with children ── */
        if (route.children) {
          const visibleChildren = route.children.filter(hasChildPermission);
          const anyChildActive = visibleChildren.some((c) => activeRoute(c.path));

          return (
            <div key={index} className="sl-group">
              {/* Group header */}
              <button
                type="button"
                className={`sl-group-btn${isOpen || anyChildActive ? " sl-group-btn--open" : ""}`}
                onClick={() => toggleMenu(route.name)}
              >
                <span className="sl-icon">
                  {route.icon ? route.icon : <DashIcon />}
                </span>
                <span className="sl-group-label">{route.name}</span>
                <span className="sl-caret">
                  {isOpen ? <AiFillCaretUp size={10} /> : <AiFillCaretDown size={10} />}
                </span>
              </button>

              {/* Children */}
              {isOpen && (
                <div className="sl-children">
                  {visibleChildren.map((child, ci) => {
                    const childActive = activeRoute(child.path);
                    return (
                      <Link
                        key={ci}
                        to={child.layout + "/" + child.path}
                        className={`sl-child${childActive ? " sl-child--active" : ""}`}
                        // onClick={() => { window.scrollTo(0, 0); setActiveTab("single"); setSettlementActiveTab("card"); onClose(); }}
                        onClick={() => {
                          window.scrollTo(0, 0);
                          setActiveTab("single");
                          setActiveSettlementTab("all-settlements");
                          setSettlementActiveTab("card");
                          if (window.innerWidth < 1280) {
                            onClose();
                          }
                        }}
                      >
                        {child.icon && <span className="sl-child-icon">{child.icon}</span>}
                        <span>{child.name.replace(/\bKyc\b/, "KYC")}</span>
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        }

        /* ── Regular route ── */
        return (
          <Link
            key={index}
            to={route.layout + "/" + route.path}
            className={`sl-item${isActive ? " sl-item--active" : ""}`}
            // onClick={() => { window.scrollTo(0, 0); setOpenMenus({}); setActiveTab("single"); setSettlementActiveTab("card"); onClose(); }}
            onClick={() => {
              window.scrollTo(0, 0);
              setOpenMenus({});
              setActiveTab("single");
              setActiveSettlementTab("all-settlements");
              setSettlementActiveTab("card");

              if (window.innerWidth < 1280) {
                onClose();
              }
            }}
          >
            <span className="sl-icon">{route.icon ? route.icon : <DashIcon />}</span>
            <span className="sl-label">{route.name}</span>
            {isActive && <span className="sl-active-bar" />}
          </Link>
        );
      }

      /* ── Auth / RTL routes ── */
      if ((route.layout === "/auth" || route.layout === "/rtl") && !route?.isHidden) {
        const isActive = activeRoute(route.path);
        return (
          <Link key={index} to={route.layout + "/" + route.path} className={`sl-item${isActive ? " sl-item--active" : ""}`}>
            <span className="sl-icon">{route.icon ? route.icon : <DashIcon />}</span>
            <span className="sl-label">{route.name}</span>
            {isActive && <span className="sl-active-bar" />}
          </Link>
        );
      }

      return null;
    });
  };

  return (
    <>
      {createLinks(routes)}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* ── Base item ── */
        .sl-item {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: relative;
          display: flex; align-items: center; gap: 10px;
          padding: 9px 16px 9px 18px;
          margin: 2px 10px;
          border-radius: 10px;
          font-size: 13px; font-weight: 600;
          color: #64748b;
          text-decoration: none;
          cursor: pointer;
          transition: background .15s, color .15s;
          overflow: hidden;
        }
        .sl-item:hover {
          background: #f1f5f9;
          color: #0f172a;
        }
        .sl-item--active {
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          color: #1d4ed8 !important;
          font-weight: 700;
        }
        .sl-item--active:hover { background: linear-gradient(135deg, #dbeafe, #bfdbfe); }

        /* Active indicator bar */
        .sl-active-bar {
          position: absolute; right: 0; top: 50%;
          transform: translateY(-50%);
          width: 3px; height: 60%;
          background: linear-gradient(180deg, #1d4ed8, #2563eb);
          border-radius: 3px 0 0 3px;
        }

        /* ── Icon ── */
        .sl-icon {
          display: flex; align-items: center; justify-content: center;
          width: 20px; flex-shrink: 0;
          opacity: 0.7;
          transition: opacity .15s;
        }
        .sl-item--active .sl-icon,
        .sl-item:hover .sl-icon { opacity: 1; }

        /* ── Label ── */
        .sl-label {
          flex: 1; line-height: 1.3;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }

        /* ── Group / parent button ── */
        .sl-group { margin-bottom: 2px; }

        .sl-group-btn {
          font-family: 'Plus Jakarta Sans', sans-serif;
          width: calc(100% - 20px);
          display: flex; align-items: center; gap: 10px;
          padding: 9px 16px 9px 18px;
          margin: 0 10px;
          border-radius: 10px;
          font-size: 13px; font-weight: 600;
          color: #64748b;
          background: none; border: none;
          cursor: pointer; text-align: left;
          transition: background .15s, color .15s;
        }
        .sl-group-btn:hover { background: #f1f5f9; color: #0f172a; }
        .sl-group-btn--open { color: #1d4ed8; font-weight: 700; }
        .sl-group-btn--open:hover { background: linear-gradient(135deg,#eff6ff,#dbeafe); }

        .sl-group-label { flex: 1; }

        .sl-caret {
          display: flex; align-items: center;
          color: #94a3b8; flex-shrink: 0;
          transition: color .15s;
        }
        .sl-group-btn--open .sl-caret { color: #2563eb; }

        /* ── Children ── */
        .sl-children {
          margin: 4px 10px 4px 28px;
          border-left: 2px solid #e2e8f0;
          padding-left: 8px;
          display: flex; flex-direction: column; gap: 1px;
        }

        .sl-child {
          font-family: 'Plus Jakarta Sans', sans-serif;
          display: flex; align-items: center; gap: 8px;
          padding: 7px 12px;
          border-radius: 8px;
          font-size: 12.5px; font-weight: 600;
          color: #64748b;
          text-decoration: none;
          transition: background .15s, color .15s;
          white-space: nowrap;
        }
        .sl-child:hover { background: #f1f5f9; color: #0f172a; }
        .sl-child--active {
          background: linear-gradient(135deg,#eff6ff,#dbeafe);
          color: #1d4ed8 !important;
          font-weight: 700;
        }
        .sl-child--active:hover { background: linear-gradient(135deg,#dbeafe,#bfdbfe); }

        .sl-child-icon { display: flex; align-items: center; opacity: 0.7; flex-shrink: 0; }
        .sl-child--active .sl-child-icon { opacity: 1; }

        /* ── Section divider (optional) ── */
        .sl-section-label {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 10px; font-weight: 700;
          color: #cbd5e1; text-transform: uppercase; letter-spacing: 0.8px;
          padding: 14px 28px 4px;
        }

        /* ── Dark mode ── */
        .dark .sl-item { color: #94a3b8; }
        .dark .sl-item:hover { background: rgba(255,255,255,0.06); color: #e2e8f0; }
        .dark .sl-item--active {
          background: rgba(37,99,235,0.15);
          color: #93c5fd !important;
        }
        .dark .sl-item--active:hover { background: rgba(37,99,235,0.22); }

        .dark .sl-group-btn { color: #94a3b8; }
        .dark .sl-group-btn:hover { background: rgba(255,255,255,0.06); color: #e2e8f0; }
        .dark .sl-group-btn--open { color: #93c5fd; }
        .dark .sl-group-btn--open:hover { background: rgba(37,99,235,0.15); }

        .dark .sl-children { border-left-color: rgba(255,255,255,0.1); }
        .dark .sl-child { color: #94a3b8; }
        .dark .sl-child:hover { background: rgba(255,255,255,0.06); color: #e2e8f0; }
        .dark .sl-child--active {
          background: rgba(37,99,235,0.15);
          color: #93c5fd !important;
        }
        .dark .sl-caret { color: rgba(255,255,255,0.3); }
        .dark .sl-group-btn--open .sl-caret { color: #93c5fd; }
      `}</style>
    </>
  );
};

export default SidebarLinks;